module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "report_container"
    }
  }, [(_vm.proj) ? _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "id": "frame_report",
      "src": "",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.proj == null) ? _c('div', {
    staticClass: "empty-reports-txt text-left"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("No Reports")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfa15aa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/Projects.vue
// module id = 571
// module chunks = 1